export const URL_PATH_WITH_PLUGIN_NAME = {
  'course-editor': 'Activities',
  courses: 'Courses',
  'learning-objectives': 'Learning Objectives',
};

export const getPluginName = (url) => {
  const regex = /\/plugins\/([^/?&]+)/;

  const matches = url.match(regex);
  const plugin = matches
    ? URL_PATH_WITH_PLUGIN_NAME[matches[1]] || null
    : null;
  return plugin;
};

export const extractPluginPath = (url) => {
  const regex = /^\/plugins\/[^\/?&]*/;
  const match = url.match(regex);
  if (match) {
    return match[0];
  }
  return null;
};
